export default "__VITE_ASSET__DVbSxbn1__"